<template>
  <div>
    <div class="bg-gray-200 d-flex align-center px-2 py-1">
      <span class="font-12 font-weight-medium">
        {{ `Carteira dos Compradores / ${breadcrumb}` }}
      </span>
    </div>

    <v-card>
      <v-tabs centered>
        <v-tab @click="breadcrumb = 'Fornecedores'">
          Fornecedores
        </v-tab>

        <v-tab @click="breadcrumb = 'Seções'">
          Seções
        </v-tab>

        <v-tab @click="breadcrumb = 'Departamentos'">
          Departamentos
        </v-tab>

        <v-tab-item class="ma-0">
          <Fornecedores
            ocultar_titulo_tela
            height_data_table="calc(100vh - 253px)"
            class="ml-n3 mr-n1"
          />
        </v-tab-item>

        <v-tab-item class="ma-0">
          <Secoes />
        </v-tab-item>

        <v-tab-item class="ma-0">
          <Departamentos />
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import Secoes from "./Secoes.vue"
import Departamentos from "./Departamentos.vue";
import Fornecedores from "../../cadastros/Fornecedor.vue"

export default {
  name: "SecoesDoComprador",
  components: {
    Secoes,
    Departamentos,
    Fornecedores
  },
  data() {
    return {
      breadcrumb: "Seções",
    };
  },
}
</script>

<style>

</style>
